import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { ChevronLeft } from "lucide-react";
import { ScrollOverHero } from "@/components/molecules/scroll-over-hero/ScrollOverHero";
import { RealEstateDetailMobileContent, RealEstateDetailMobileSubcontent } from "./RealEstateDetailMobile.atoms";

// The shared shell of the mobile detail: scroll root, sticky back bar, hero
// region and the body container. Compositions (the loaded detail and its
// loading skeleton) plug their content into the slots so the outer structure
// stays identical.
export function RealEstateDetailMobileScaffold(t0) {
  const $ = _c(24);
  const {
    overlay,
    fab,
    onBack,
    backLabel,
    actions,
    hero,
    heroBadge,
    fadeDistance: t1,
    scrollable: t2,
    children
  } = t0;
  const fadeDistance = t1 === undefined ? 480 : t1;
  const scrollable = t2 === undefined ? true : t2;
  const scrollRef = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronLeft data-sentry-element="ChevronLeft" data-sentry-source-file="RealEstateDetailMobileScaffold.tsx" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== backLabel) {
    t4 = <span>{backLabel}</span>;
    $[1] = backLabel;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onBack || $[4] !== t4) {
    t5 = <div className="flex items-center gap-2 text-foreground" onClick={onBack}>{t3}{t4}</div>;
    $[3] = onBack;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== actions) {
    t6 = <div className="flex gap-3 items-center">{actions}</div>;
    $[6] = actions;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <div className="sticky top-0 z-50 flex items-center justify-between py-4 px-4 bg-card border-b shadow-xs">{t5}{t6}</div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== children) {
    t8 = <RealEstateDetailMobileSubcontent data-sentry-element="RealEstateDetailMobileSubcontent" data-sentry-source-file="RealEstateDetailMobileScaffold.tsx">{children}</RealEstateDetailMobileSubcontent>;
    $[11] = children;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== fadeDistance || $[14] !== hero || $[15] !== heroBadge || $[16] !== t8) {
    t9 = <div className="pb-20 bg-background"><ScrollOverHero scrollContainerRef={scrollRef} fadeDistance={fadeDistance} hero={hero} drawerBadgeClassName="right-[18px] mb-4" drawerBadge={heroBadge} data-sentry-element="ScrollOverHero" data-sentry-source-file="RealEstateDetailMobileScaffold.tsx">{t8}</ScrollOverHero></div>;
    $[13] = fadeDistance;
    $[14] = hero;
    $[15] = heroBadge;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== fab || $[19] !== overlay || $[20] !== scrollable || $[21] !== t7 || $[22] !== t9) {
    t10 = <RealEstateDetailMobileContent ref={scrollRef} scrollable={scrollable} data-sentry-element="RealEstateDetailMobileContent" data-sentry-component="RealEstateDetailMobileScaffold" data-sentry-source-file="RealEstateDetailMobileScaffold.tsx">{overlay}{fab}{t7}{t9}</RealEstateDetailMobileContent>;
    $[18] = fab;
    $[19] = overlay;
    $[20] = scrollable;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}